import { TableV2 } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { TableData } from '@anytag/shared-types';
import { TiktokAdAccountInfo } from '@anytag/graphql';
import { useAdvertiserAdAccountsTable } from './hooks';

export type AdvertiserAdAccountsListProps = TableData<TiktokAdAccountInfo>;

export const AdvertiserAdAccountsList = ({ loading, data = [] }: AdvertiserAdAccountsListProps) => {
  const { columns } = useAdvertiserAdAccountsTable();

  return (
    <TableV2
      loading={loading}
      data={data}
      columns={columns}
      empty={{ hideDescription: true }}
      css={{ boxShadow: THEME.shadows.boxShadow }}
      noTopBorderRadius
    />
  );
};
